export default __webpack_public_path__ + "static/media/resdential.bde2a4ac.jpg";